import { apiClient, handleError } from '../../../../api/ApiClient';

export const searchAdminManagers = (search, successCallback) => (dispatch) =>
  apiClient
    .post('/admin/search/admin-manager', { search, page: 0, limit: 50 })
    .then((res) => successCallback(res.data))
    .catch((err) => dispatch(handleError(err)));
